<template>
    <div>
        <div class="clearfix mt10 mb10">
            <div class="fl">
                <el-checkbox class="ml15" v-model="selected" @change="changeSelected">来源</el-checkbox>
            </div>
            <div class="fr">
                <div class="search-container primary">
                    <div class="form-box">
                        <input class="input-field" v-model="title" placeholder="询盘名称"/>
                        <button class="search-btn" @click="getdealInqryVoucherList()"><i class="icon iconfont icon-search"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="column-layout">
            <div class="table-layout">
                <el-table :height="500+'px'" ref="multipleTable" :data="dealInqryVoucherList" border tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange">
                    <el-table-column width="55" v-if="showSelect">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : checlDealInqryVoucher!= null && checlDealInqryVoucher.id == rows.row.id}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="no" label="询盘单号" width="183">
                        <template slot-scope="rows">
                            <a class="swb-btn-link" @click.stop="toDealInqryVoucherList(rows.row.no)">{{rows.row.no}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="询盘名称"></el-table-column>
                    <el-table-column prop="publishTime" label="发布日期"></el-table-column>
                    <el-table-column prop="expireDate" label="截止日期" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="contactName" label="联系人" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import dealApi from '../../api/deal'


    export default{
        name: 'swb-deal-inqry-voucher-for-select',
        desc: '询盘选择(合同用)',
        props: {
            rowId: {},
            showSelect: {
                type: Boolean,
                default: false
            },
            toDealInqryVoucher: {
                type: Function
            },
            type: {
                type: String
            }
        },
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                dealInqryVoucherList: [],
                title: null,
                checlDealInqryVoucher: {
                    id: null
                },
                dealInqryFlag: {},
                goodsTradeType: {},
                servcTradeType: {},

                selected: false

            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            let self = this;
            if(self.rowId != null && self.rowId != '') {
                self.checlDealInqryVoucher.id = self.rowId;
                self.selected = true;
            }

            self.dealInqryFlag = getEnumInfoWith('bizSrcFlag', 'name', 'DealInqry');

            self.goodsTradeType = getEnumInfoWith('tradeType', 'name', 'Goods');
            self.servcTradeType = getEnumInfoWith('tradeType', 'name', 'Servc');
            //
            self.getdealInqryVoucherList();
        },
        methods: {
            changeSelected() {
                this.getdealInqryVoucherList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getdealInqryVoucherList();
            },
            getdealInqryVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                filterItems.closedState = 0;
                if(!Utils.isNoB(self.title)) {
                    filterItems.title = self.title;
                }
                if(self.type == "goods") {
                    filterItems.tradeType = self.goodsTradeType.value;
                } else {
                    filterItems.tradeType = self.servcTradeType.value;
                }
                if(self.rowId != null && self.rowId != '' && self.selected) {
                    filterItems.id = self.rowId;
                } else if(self.selected) {
                    self.dealInqryVoucherList = [];
                    return false;
                }
                postData.filterItems = filterItems;
                let lastMsgBoxDlg = MsgBox.loading();
                dealApi.getDealInqryVoucherList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let dealInqryVoucherList = result.data.rows;
                        for(let i = 0, count = dealInqryVoucherList.length; i < count; i++) {
                            let dealInqryVoucher = dealInqryVoucherList[i];
                            if(dealInqryVoucher.publishTime != null) {
                                dealInqryVoucher.publishTime = Date.parseAsDate(dealInqryVoucher.publishTime).format("yyyy-MM-dd");
                            }
                            dealInqryVoucher.merchantCount = dealInqryVoucher.dealInqryMerchtList.length;
                        }
                        self.dealInqryVoucherList = dealInqryVoucherList;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleCurrentChange: function (val) {
                this.checlDealInqryVoucher = Utils.merge({}, val);
            },
            getDlgResult: function () {
                let self = this;
                let returnInfo = null;
                let dealInqryVoucher = self.checlDealInqryVoucher;
                if(dealInqryVoucher.id != null) {
                    returnInfo = {};
                    returnInfo.srcId = dealInqryVoucher.id;
                    returnInfo.srcWinId = null;
                    returnInfo.srcFlag = self.dealInqryFlag.value;
                }
                return returnInfo;
            },
            toDealInqryVoucherList: function (no) {
                this.toDealInqryVoucher.call(parent, no);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/InqryVoucher/DealInqryVoucherForSelect.vue